import { useContext, useEffect } from "react";
import styled from "styled-components";
import { DropdownContext } from "../../contexts/DropdownContext";

interface IDropdownList {
  dropdownIsOpen: boolean;
  choices: { label: any; icon: any | undefined }[];
  dropdownSelected: any;
  onclick: Function;
  setDropdownIsOpen: Function;
  css?: any;
}
const DropdownList = ({
  dropdownIsOpen,
  choices,
  dropdownSelected,
  onclick,
  setDropdownIsOpen,
  css,
}: IDropdownList) => {
  const { dropdownRef, setDropdownRef } = useContext(DropdownContext);
  useEffect(() => {
    if (!dropdownIsOpen) {
      setDropdownRef(null);
    } else {
      setDropdownRef("dropdown");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownIsOpen]);
  useEffect(() => {
    if (!dropdownRef) {
      setDropdownIsOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropdownRef]);
  return (
    <>
      {dropdownIsOpen && (
        <SSelector style={css}>
          {choices.map((choice, i) => {
            return (
              <SChoice
                className={choice.label === dropdownSelected ? "selected" : ""}
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  onclick(choice.label);
                }}
              >
                {choice.icon && <SIcon alt={choice.label} src={choice.icon} />}
                {choice.label}
              </SChoice>
            );
          })}
        </SSelector>
      )}
    </>
  );
};
export default DropdownList;
const SIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 12px;
`;
const SSelector = styled.div`
  position: absolute;
  margin-top: 312px;
  margin-left: -21px;
  width: 100%;
  background: var(--color-surface);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 6px;
  z-index: 20;
  animation: fadeSlide 160ms ease-out;
  @keyframes fadeSlide {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
const SChoice = styled.div`
  padding: 10px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: var(--radius-xs);
  color: var(--color-text);
  font-size: 14px;
  transition:
    background-color var(--transition),
    color var(--transition);
  &:hover {
    background-color: var(--color-primary-soft);
    color: var(--color-primary);
  }
  &.selected {
    color: var(--color-primary);
    font-weight: 600;
    background-color: var(--color-primary-soft);
  }
`;
